/*
 * @Author: BuzzLightyear.Z
 * @Date: 2022-02-15 11:46:26
 * @LastEditTime: 2022-02-16 15:12:53
 * @Description: 阿里云OSS相关配置
 */

import OSS from "ali-oss";

type OSSConfigType = {
  access_key_id: string;
  access_key_secret: string;
  bucket_cdn: string;
  bucket_endpoint: string;
  bucket_name: string;
  expiration: string;
  security_token: string;
};

export const getOSSConfig = async (config?: OSSConfigType) => {
  const baseConfig: any = {
    accessKeyId: config?.access_key_id ?? "LTAI5t6TQNBxfYZNeZUsPNPy",
    accessKeySecret: config?.access_key_secret ?? "RqAWMOE4ng2ILBwfHV34GihGwMByso",
    endpoint:
      config?.bucket_endpoint.replace("-internal", "") ?? "https://oss-cn-hangzhou.aliyuncs.com",
    bucket: config?.bucket_name ?? "nolipix-preview",
    bucketCDN: config?.bucket_cdn ?? "nolipix-preview",
    stsToken: config?.security_token,
  };
  const ossKeys = [
    "accessKeyId",
    "accessKeySecret",
    "stsToken",
    "endpoint",
    "bucket",
    "refreshSTSTokenInterval",
  ];
  const ossConfig: { accessKeyId: string; accessKeySecret: string; stsToken: string } =
    ossKeys.reduce((options: any, ossKey: string) => {
      options[ossKey] = baseConfig[ossKey];
      return options;
    }, {}) as any;
  return {
    ossConfig,
    baseConfig,
  };
};
export const createClient = async (config?: OSSConfigType, region?: string) => {
  const { ossConfig, baseConfig } = await getOSSConfig(config);
  console.log("baseConfig: ", baseConfig);
  console.log("ossConfig: ", ossConfig);
  const client = new OSS({
    ...ossConfig,
    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    region: region ?? "oss-cn-hangzhou",
    refreshSTSToken: async () => {
      // 向您搭建的STS服务获取临时访问凭证。
      const { ossConfig: oc } = await getOSSConfig();
      return oc;
    },
  });
  return {
    client,
    baseConfig,
  };
};

export async function clientPut({
  file,
  client,
  filePath,
  publicRead = true,
}: {
  file: any;
  client: any;
  filePath?: any;
  publicRead?: any;
}): Promise<{ url: string; res: { status: number } }> {
  return client.put(filePath, file).then((result: any) => {
    if (publicRead) client.putACL(filePath, "public-read");
    return result;
  });
}
